import { useEffect, useMemo, useState } from 'react';
import { heroBackgrounds, heroTiming } from '../../data/backgrounds';

export default function HeroBackground() {
  const images = useMemo(() => heroBackgrounds, []);
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    images.forEach((src) => {
      const image = new Image();
      image.src = src;
    });
  }, [images]);

  useEffect(() => {
    if (images.length < 2) return undefined;

    const interval = window.setInterval(() => {
      setActiveIndex((current) => (current + 1) % images.length);
    }, heroTiming.displayMs);

    return () => window.clearInterval(interval);
  }, [images.length]);

  return (
    <div className="hero-background" aria-hidden="true">
      {images.map((src, index) => (
        <div
          key={src}
          className={`hero-background__image${index === activeIndex ? ' is-active' : ''}`}
          style={{
            backgroundImage: `url("${src}")`,
            transitionDuration: `${heroTiming.fadeMs}ms`
          }}
        />
      ))}
      <div className="hero-background__overlay" />
    </div>
  );
}
